import {parseTime} from '@/utils/index';
import store from '@/store';
/**
 * 解析分隔指令
 * @param {*} el 当前dom节点 
 * @param {*} options 指令选项
 */
const fmoneyAnalysis = (el, options = {}) => {
  let decimal = {fixed: 2};
  if (options.arg) {
    const data = eval("("+options.arg+")");
    decimal.fixed = !data.fixed && data.fixed !==0 ? 2 : data.fixed;
  }
  const isInt = /^\d+$/.test(options.value);
  const value = fmoney(options.value, isInt ? 0 : decimal.fixed);
  el.innerText = value;
}

/**
 * 金额逗号分隔展示
 * @param {*} s 总金额
 * @param {*} n 保留小数位数
 */
const fmoney = (s, n) => {
  n = n >= 0 && n <= 10 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + ""; 
  let l = s.split(".")[0].split("").reverse(), r = s.split(".")[1];  
  let t = "";  
  for (let i = 0; i < l.length; i++) {  
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");  
  }  
  return t.split("").reverse().join("") + `${n === 0 ? '' : "." + r}`;
}

/**
 * 解析时间格式
 * @param {*} el 当前dom节点 
 * @param {*} options 指令选项
 */
const analysisTime = (el, options) => {
  const value = options.value;
  let text = '--';
  if (value && value !== '') {
    let format = '{y}-{m}-{d} {h}:{i}';
    if (options.arg === 'all') format = '{y}-{m}-{d} {h}:{i}:{s}';
    else if (options.arg === 'date') format = '{y}-{m}-{d}';
    text = parseTime(value, format);
  }
  el.innerText = text;
}

/**
 * 权限校验指令
 * @param {*} el 当前dom节点 
 * @param {*} options 指令选项
 */
const analysisPermission = async (el, options) => {
  const hasRole = await store.dispatch('user/hasPermission', options.value);
  if (hasRole === false) {
    // 兼容IE
    if (el.remove) el.remove();
    else {
      const parent = el.parentNode;
      parent.removeChild ? parent.removeChild(el) : '';
    }
  }
}

export default {
  'comma': fmoneyAnalysis,
  'fmoney': fmoney,
  'analysis-time': analysisTime,
  'permission': analysisPermission
}